'use client';

import { ReactNode } from 'react';
import styles from './siteNav.module.scss';

const HeaderSponsorLink = ({
  url,
  target,
  image,
}: {
  url?: string;
  target?: string;
  image?: ReactNode;
}) =>
  url ? (
    <a
      href={url}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      className={styles.sponsorTrigger}
    >
      {image}
    </a>
  ) : (
    <div className={styles.sponsorTrigger}>{image}</div>
  );

export default HeaderSponsorLink;
